import { Autocomplete, Box, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, OutlinedInput, Switch, TextField, Typography } from "@mui/material";
import { ConnectionType, DissipationType, DrainLocation, ElectricalPhase, GasLocation, GasType, Hertz, Network, PlugType, VentType, VoltageType, Volts } from "../../../../common/const";
import { showNotification } from "../../../../common/Notification/ToastifyNotification";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function MEP({
    electricalData,
    setElectricalData,
    mechanicalData,
    setMechanicalData,
    plumbingData,
    setPlumbingData,
    technicalData,
    setTechnicalData
}) {
    return (
        <Grid container>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Box style={{ marginTop: 10, paddingBottom: 10 }}>
                    <Typography variant="body1" style={{ fontWeight: 'bold' }}>Mechanical</Typography>
                </Box>
                <Grid container spacing={1} style={{ marginBottom: 10 }}>
                    <Grid item xs={12} sm={8} md={8} lg={8}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Heat Dissipation BTU/Hr</InputLabel>
                            <OutlinedInput
                                label="Heat Dissipation BTU/Hr"
                                id="standard-adornment-password"
                                type='number'
                                value={mechanicalData?.heatDissipation}
                                onChange={(e) => {
                                    setMechanicalData((prevData) => ({
                                        ...prevData,
                                        heatDissipation: e.target?.value
                                    }));
                                }}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 38 || event.keyCode === 40) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={4} md={4} lg={4} />
                    <Grid item xs={12} sm={8} md={8} lg={8}>
                        <Autocomplete
                            value={DissipationType.find((c) => c.value === mechanicalData?.dissipationType) || null}
                            id="combo-box-demo"
                            size="small"
                            fullWidth
                            options={DissipationType}
                            getOptionLabel={(option) => option?.name}
                            onChange={(event, newValue) => {
                                setMechanicalData((prevData) => ({
                                    ...prevData,
                                    dissipationType: newValue?.value || null
                                }));
                            }}
                            renderInput={(params) => <TextField fullWidth {...params} label="Dissipation Type" name="Dissipation Type" variant="outlined" />}
                        />
                    </Grid>
                    <Grid item sm={4} md={4} lg={4} />
                    <Grid item xs={12} sm={8} md={8} lg={8}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={mechanicalData?.vent}
                                        onClick={(e) => {
                                            setMechanicalData((prevData) => ({
                                                ...prevData,
                                                vent: e.target.checked,
                                                ventType: null
                                            }));
                                        }}
                                    />}
                                label="Vent Needed"
                            />
                        </FormGroup>
                    </Grid>
                    <Grid item sm={4} md={4} lg={4} />
                    <Grid item xs={12} sm={8} md={8} lg={8}>
                        <Autocomplete
                            value={VentType.find((c) => c.value === mechanicalData?.ventType) || null}
                            id="combo-box-demo"
                            size="small"
                            fullWidth
                            options={VentType}
                            getOptionLabel={(option) => option?.name}
                            disabled={!mechanicalData?.vent}
                            onChange={(event, newValue) => {
                                setMechanicalData((prevData) => ({
                                    ...prevData,
                                    ventType: newValue?.value || null
                                }));
                            }}
                            renderInput={(params) => <TextField fullWidth {...params} label="Vent Type" name="Vent Type" variant="outlined" />}
                        />
                    </Grid>
                    <Grid item sm={4} md={4} lg={4} />
                    <Grid item xs={12} sm={8} md={8} lg={8}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Mechanical Remarks</InputLabel>
                            <OutlinedInput
                                label="Mechanical Remarks"
                                id="standard-adornment-password"
                                type='text'
                                multiline
                                minRows={5}
                                value={mechanicalData?.mechanicalRemarks}
                                onChange={(e) => {
                                    if (e.target.value?.length > 300) {
                                        showNotification('The Remarks should be maximum 300 characters long', 'error');
                                    } else {
                                        setMechanicalData((prevData) => ({
                                            ...prevData,
                                            mechanicalRemarks: e.target.value,
                                        }));
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Box style={{ marginTop: 10, paddingBottom: 10 }}>
                    <Typography variant="body1" style={{ fontWeight: 'bold' }}>Electrical</Typography>
                </Box>
                <Grid container spacing={1} style={{ marginBottom: 10 }}>
                    <Grid item xs={12} sm={8} md={8} lg={8}>
                        <Autocomplete
                            value={VoltageType.find((c) => c.value === electricalData?.voltageType) || null}
                            id="combo-box-demo"
                            size="small"
                            fullWidth
                            options={VoltageType}
                            getOptionLabel={(option) => option?.name}
                            onChange={(event, newValue) => {
                                setElectricalData((prevData) => ({
                                    ...prevData,
                                    voltageType: newValue?.value || null
                                }));
                            }}
                            renderInput={(params) => <TextField fullWidth {...params} label="Voltage Type" name="Voltage Type" variant="outlined" />}
                        />
                    </Grid>
                    <Grid item sm={4} md={4} lg={4} />
                    <Grid item xs={12} sm={8} md={8} lg={8}>
                        <Autocomplete
                            value={Volts.find((c) => c.value === electricalData?.volts) || null}
                            id="combo-box-demo"
                            size="small"
                            fullWidth
                            options={Volts}
                            getOptionLabel={(option) => option?.name}
                            onChange={(event, newValue) => {
                                setElectricalData((prevData) => ({
                                    ...prevData,
                                    volts: newValue?.value || null
                                }));
                            }}
                            renderInput={(params) => <TextField fullWidth {...params} label="Volts" name="Volts" variant="outlined" />}
                        />
                    </Grid>
                    <Grid item sm={4} md={4} lg={4} />
                    <Grid item xs={12} sm={8} md={8} lg={8}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Amps</InputLabel>
                            <OutlinedInput
                                label="Amps"
                                id="standard-adornment-password"
                                type='text'
                                value={electricalData?.amps}
                                onChange={(e) => {
                                    setElectricalData((prevData) => ({
                                        ...prevData,
                                        amps: e.target?.value
                                    }));
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={4} md={4} lg={4} />
                    <Grid item xs={12} sm={8} md={8} lg={8}>
                        <Autocomplete
                            value={Hertz.find((c) => c.value === electricalData?.hertz) || null}
                            id="combo-box-demo"
                            size="small"
                            fullWidth
                            options={Hertz}
                            getOptionLabel={(option) => option?.name}
                            onChange={(event, newValue) => {
                                setElectricalData((prevData) => ({
                                    ...prevData,
                                    hertz: newValue?.value || null
                                }));
                            }}
                            renderInput={(params) => <TextField fullWidth {...params} label="Hertz" name="Hertz" variant="outlined" />}
                        />
                    </Grid>
                    <Grid item sm={4} md={4} lg={4} />
                    <Grid item xs={12} sm={8} md={8} lg={8}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Watts</InputLabel>
                            <OutlinedInput
                                label="Watts"
                                id="standard-adornment-password"
                                type='text'
                                value={electricalData?.watts}
                                onChange={(e) => {
                                    setElectricalData((prevData) => ({
                                        ...prevData,
                                        watts: e.target?.value
                                    }));
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={4} md={4} lg={4} />
                    <Grid item xs={12} sm={8} md={8} lg={8}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">kVA</InputLabel>
                            <OutlinedInput
                                label="kVA"
                                id="standard-adornment-password"
                                type='text'
                                value={electricalData?.kva}
                                onChange={(e) => {
                                    setElectricalData((prevData) => ({
                                        ...prevData,
                                        kva: e.target?.value
                                    }));
                                }}
                                onKeyDown={(event) => {
                                    if (event.keyCode === 38 || event.keyCode === 40) {
                                        event.preventDefault();
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={4} md={4} lg={4} />
                    <Grid item xs={12} sm={8} md={8} lg={8}>
                        <Autocomplete
                            value={ElectricalPhase.find((c) => c.value === electricalData?.electricalPhase) || null}
                            id="combo-box-demo"
                            size="small"
                            fullWidth
                            options={ElectricalPhase}
                            getOptionLabel={(option) => option?.name}
                            onChange={(event, newValue) => {
                                setElectricalData((prevData) => ({
                                    ...prevData,
                                    electricalPhase: newValue?.value || null
                                }));
                            }}
                            renderInput={(params) => <TextField fullWidth {...params} label="Phase" name="Phase" variant="outlined" />}
                        />
                    </Grid>
                    <Grid item sm={4} md={4} lg={4} />
                    <Grid item xs={12} sm={8} md={8} lg={8}>
                        <Autocomplete
                            value={PlugType.find((c) => c.value === electricalData?.plugtype) || null}
                            id="combo-box-demo"
                            size="small"
                            fullWidth
                            options={PlugType}
                            getOptionLabel={(option) => option?.name}
                            onChange={(event, newValue) => {
                                setElectricalData((prevData) => ({
                                    ...prevData,
                                    plugtype: newValue?.value || null
                                }));
                            }}
                            renderInput={(params) => <TextField fullWidth {...params} label="Plug Type" name="Plug Type" variant="outlined" />}
                        />
                    </Grid>
                    <Grid item sm={4} md={4} lg={4} />
                    <Grid item xs={12} sm={8} md={8} lg={8}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Plug Details</InputLabel>
                            <OutlinedInput
                                label="Plug Details"
                                id="standard-adornment-password"
                                type='text'
                                value={electricalData?.plugdetail}
                                onChange={(e) => {
                                    setElectricalData((prevData) => ({
                                        ...prevData,
                                        plugdetail: e.target?.value
                                    }));
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item sm={4} md={4} lg={4} />
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={electricalData?.dedicatedCircuit}
                                        onClick={(e) => {
                                            setElectricalData((prevData) => ({
                                                ...prevData,
                                                dedicatedCircuit: e.target.checked
                                            }));
                                        }}
                                    />}
                                label="Dedicated Circuit"
                            />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={electricalData?.emergencyPower}
                                        onClick={(e) => {
                                            setElectricalData((prevData) => ({
                                                ...prevData,
                                                emergencyPower: e.target.checked
                                            }));
                                        }}
                                    />}
                                label="Emergency Power"
                            />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={electricalData?.remoteTrans}
                                        onClick={(e) => {
                                            setElectricalData((prevData) => ({
                                                ...prevData,
                                                remoteTrans: e.target.checked
                                            }));
                                        }}
                                    />}
                                label="Remote Transformer"
                            />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={electricalData?.remoteSwitch}
                                        onClick={(e) => {
                                            setElectricalData((prevData) => ({
                                                ...prevData,
                                                remoteSwitch: e.target.checked
                                            }));
                                        }}
                                    />}
                                label="Remote Switch/Controller"
                            />
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={8} md={8} lg={8}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Electrical Remarks</InputLabel>
                            <OutlinedInput
                                label="Electrical Remarks"
                                id="standard-adornment-password"
                                type='text'
                                multiline
                                minRows={5}
                                value={electricalData?.electricalRemarks}
                                onChange={(e) => {
                                    if (e.target.value?.length > 300) {
                                        showNotification('The Remarks should be maximum 300 characters long', 'error');
                                    } else {
                                        setElectricalData((prevData) => ({
                                            ...prevData,
                                            electricalRemarks: e.target.value,
                                        }));
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3}>
                <Box style={{ marginTop: 10 }}>
                    <Typography variant="body1" style={{ fontWeight: 'bold' }}>Plumbing</Typography>
                </Box>
                <Grid container spacing={2} style={{ marginBottom: 10 }}>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={plumbingData?.hotWater}
                                        onClick={(e) => {
                                            setPlumbingData((prevData) => ({
                                                ...prevData,
                                                hotWater: e.target.checked
                                            }));
                                        }}
                                    />}
                                label="Hot Water"
                            />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={plumbingData?.coldWater}
                                        onClick={(e) => {
                                            setPlumbingData((prevData) => ({
                                                ...prevData,
                                                coldWater: e.target.checked
                                            }));
                                        }}
                                    />}
                                label="Cold Water"
                            />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={plumbingData?.treatedWater}
                                        onClick={(e) => {
                                            setPlumbingData((prevData) => ({
                                                ...prevData,
                                                treatedWater: e.target.checked
                                            }));
                                        }}
                                    />}
                                label="Treated Water"
                            />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={plumbingData?.drain}
                                        onClick={(e) => {
                                            setPlumbingData((prevData) => ({
                                                ...prevData,
                                                drain: e.target.checked,
                                                drainLocation: null
                                            }));
                                        }}
                                    />}
                                label="Drain"
                            />
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={plumbingData?.steam}
                                        onClick={(e) => {
                                            setPlumbingData((prevData) => ({
                                                ...prevData,
                                                steam: e.target.checked
                                            }));
                                        }}
                                    />}
                                label="Steam"
                            />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={plumbingData?.vaccumMedical}
                                        onClick={(e) => {
                                            setPlumbingData((prevData) => ({
                                                ...prevData,
                                                vaccumMedical: e.target.checked
                                            }));
                                        }}
                                    />}
                                label="Vaccum - Medical"
                            />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={plumbingData?.vaccumDental}
                                        onClick={(e) => {
                                            setPlumbingData((prevData) => ({
                                                ...prevData,
                                                vaccumDental: e.target.checked
                                            }));
                                        }}
                                    />}
                                label="Vaccum - Dental"
                            />
                        </FormGroup>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Checkbox
                                        checked={plumbingData?.medicalGas}
                                        onClick={(e) => {
                                            setPlumbingData((prevData) => ({
                                                ...prevData,
                                                medicalGas: e.target.checked,
                                                gasType: [],
                                                gasLocation: null
                                            }));
                                        }}
                                    />}
                                label="Medical Gas"
                            />
                        </FormGroup>
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Autocomplete
                            value={DrainLocation.find((c) => c.value === plumbingData?.drainLocation) || null}
                            id="combo-box-demo"
                            size="small"
                            fullWidth
                            disabled={!plumbingData?.drain}
                            options={DrainLocation}
                            getOptionLabel={(option) => option?.name}
                            onChange={(event, newValue) => {
                                setPlumbingData((prevData) => ({
                                    ...prevData,
                                    drainLocation: newValue?.value
                                }));
                            }}
                            renderInput={(params) => <TextField fullWidth {...params} label="Drain Location" name="Drain Location" variant="outlined" />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Autocomplete
                            value={GasType.filter((c) => plumbingData?.gasType?.includes(c.value)) || []}
                            id="combo-box-demo"
                            size="small"
                            fullWidth
                            options={GasType}
                            multiple
                            disabled={!plumbingData?.medicalGas}
                            getOptionLabel={(option) => option?.name}
                            onChange={(event, newValue) => {
                                setPlumbingData((prevData) => ({
                                    ...prevData,
                                    gasType: newValue?.map((a) => a.value)
                                }));
                            }}
                            renderOption={(props, option, { selected }) => {
                                const { key, ...optionProps } = props;
                                return (
                                    <li key={key} {...optionProps}>
                                        <Checkbox
                                            icon={icon}
                                            checkedIcon={checkedIcon}
                                            style={{ marginRight: 8 }}
                                            checked={selected}
                                        />
                                        {option?.name}
                                    </li>
                                );
                            }}
                            renderInput={(params) => <TextField fullWidth {...params} label="Gas Type" name="Gas Type" variant="outlined" />}
                        />
                    </Grid>
                    <Grid item sm={6} md={6} lg={6} />
                    <Grid item xs={12} sm={6} md={6} lg={6}>
                        <Autocomplete
                            value={GasLocation.find((c) => c.value === plumbingData?.gasLocation) || null}
                            id="combo-box-demo"
                            size="small"
                            fullWidth
                            options={GasLocation}
                            disabled={!plumbingData?.medicalGas}
                            getOptionLabel={(option) => option?.name}
                            onChange={(event, newValue) => {
                                setPlumbingData((prevData) => ({
                                    ...prevData,
                                    gasLocation: newValue?.value
                                }));
                            }}
                            renderInput={(params) => <TextField fullWidth {...params} label="Gas Location" name="Gas Location" variant="outlined" />}
                        />
                    </Grid>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormControl size="small" fullWidth variant="outlined">
                            <InputLabel htmlFor="standard-adornment-password">Plumbing Remarks</InputLabel>
                            <OutlinedInput
                                label="Plumbing Remarks"
                                id="standard-adornment-password"
                                type='text'
                                multiline
                                minRows={5}
                                value={plumbingData?.plumbingRemarks}
                                onChange={(e) => {
                                    if (e.target.value?.length > 300) {
                                        showNotification('The Remarks should be maximum 300 characters long', 'error');
                                    } else {
                                        setPlumbingData((prevData) => ({
                                            ...prevData,
                                            plumbingRemarks: e.target.value,
                                        }));
                                    }
                                }}
                            />
                        </FormControl>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item xs={12} sm={6} md={3} lg={3} style={{ paddingLeft: 50 }}>
                <Box style={{ marginTop: 10 }}>
                    <Typography variant="body1" style={{ fontWeight: 'bold' }}>Tech Connection</Typography>
                </Box>
                <Grid container spacing={2} style={{ marginBottom: 10 }}>
                    <Grid item xs={12} sm={12} md={12} lg={12}>
                        <FormGroup>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={technicalData?.isConnection}
                                        onClick={(e) => {
                                            setTechnicalData((prevData) => ({
                                                ...prevData,
                                                isConnection: e.target.checked,
                                                connectionType: e.target.checked ? ConnectionType?.[0].value : null,
                                                network: e.target?.checked ? Network?.[0].value : null,
                                            }));
                                        }}
                                    />}
                                label="Has Technical Connections"
                            />
                        </FormGroup>
                    </Grid>
                    {technicalData?.isConnection && (
                        <>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Autocomplete
                                    value={ConnectionType.find((c) => c.value === technicalData?.connectionType) || null}
                                    id="combo-box-demo"
                                    size="small"
                                    fullWidth
                                    options={ConnectionType}
                                    getOptionLabel={(option) => option?.name}
                                    onChange={(event, newValue) => {
                                        setTechnicalData((prevData) => ({
                                            ...prevData,
                                            connectionType: newValue?.value || ConnectionType?.[0].value,
                                        }));
                                    }}
                                    renderInput={(params) => <TextField fullWidth {...params} label="Connection Type" name="Connection Type" variant="outlined" />}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <Autocomplete
                                    value={Network.find((c) => c.value === technicalData?.network) || null}
                                    id="combo-box-demo"
                                    size="small"
                                    fullWidth
                                    options={Network}
                                    getOptionLabel={(option) => option?.name}
                                    onChange={(event, newValue) => {
                                        setTechnicalData((prevData) => ({
                                            ...prevData,
                                            network: newValue?.value || Network?.[0].value,
                                        }));
                                    }}
                                    renderInput={(params) => <TextField fullWidth {...params} label="Network" name="Network" variant="outlined" />}
                                />
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={12}>
                                <FormControl size="small" fullWidth variant="outlined">
                                    <InputLabel htmlFor="standard-adornment-password">Technical Remarks</InputLabel>
                                    <OutlinedInput
                                        label="Technical Remarks"
                                        id="standard-adornment-password"
                                        type='text'
                                        multiline
                                        minRows={5}
                                        value={technicalData?.techRemarks}
                                        onChange={(e) => {
                                            if (e.target.value?.length > 300) {
                                                showNotification('The Remarks should be maximum 300 characters long', 'error');
                                            } else {
                                                setTechnicalData((prevData) => ({
                                                    ...prevData,
                                                    techRemarks: e.target.value,
                                                }));
                                            }
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                        </>
                    )}
                </Grid>
            </Grid>
        </Grid>
    )
}